import plorbinEffects from './plorbin-effects/plorbinEffects'

// `PlorbinText` is a component 
// containing plorbin text :P
const PlorbinText = () => {
    let plorbinTextOptions = []
    // If `today` is Anneka's birthday
    // update plorbinTextOptions to 
    // celebratory text
    const today = String(`${new Date().getMonth()+1}-${new Date().getDate()}`)
    if (today === '4-9') {
        plorbinTextOptions = [
            'it\'s plorbin time',
            'hbd plorbin',
            'yippee porgin',
            'plorbirth'
        ]
    } else {
        // String options for PlorbinText
        plorbinTextOptions = [
            'plorbin',
            'plorbin.',
            'plorbin :3',
            'plorbin >:(',
            'PLORBIN B)',
            'plorbin ;P',
            'plorbin :)',
            'plorbin ://',
            'plörbĩn',
            'plorbin!',
            'plorbin...',
            'plorbin?',
            'ploorbin..',
            'PLORBIN.',
            'plorb',
            'plorb.',
            'plorb..',
            'plorb?',
            'plorb uwu',
            'plrbn',
            'porgin',
            'ploOoOrbin',
            'plooorbiiin',
            'plor...bin...',
            'plorbin.com',
        ]
    }

    // Get random index for `plorbinTextOptions`
    const plorbinTextOption = plorbinTextOptions[Math.floor(Math.random() * plorbinTextOptions.length)]

    // Get random index for `plorbinEffect` using [plorbinEffects]
    const plorbinEffect = plorbinEffects[Math.floor(Math.random() * plorbinEffects.length)]

    // Import only current plorbin-effect css file
    import(`./plorbin-effects/${plorbinEffect}.css`)

    // Return div#plorbin-text with random plorbinTextOption
    return <div id="plorbin-text"><p className={`plorbin-effect ${plorbinEffect}`} data-shadow={plorbinTextOption}>{plorbinTextOption}</p></div>
}

export default PlorbinText